import { IInvoice } from '../../types/invoice';
import OrderEnum from '../../enumerables/order-enum';
import GeneralEnum from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import { changeToZeroMoment } from '../timeHelpers';
import { numberWithCommas } from '../format';

export const groupInvoiceToCsv = (data: IInvoice[]) => {
    const groupData: any = [
        [
            'id',
            'Invoice Date',
            'Invoice Total',
            'Case Number',
            'Provider',
            'Student',
            'Vendor',
            'District',
            'Service Type',
            'Service Period',
            'Order Type',
            'Note',
            'Status',
            'Written-off reason',
        ],
    ];
    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const statusEnum = GeneralEnum ? GeneralEnum.getEnum('InvoiceStatus') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);
    const statuses: SelectObject[] = getValFromEnum(statusEnum);

    data.forEach((it) => {
        const providerTitle: string = it?.provider?.fullName ? it.provider?.fullName : '';
        const vendor: string = it.vendor?.name ? it.vendor?.name : '';
        let createdAt: any = it.createdAt;

        const invoiceTotal: any = it.invoiceTotal ? it.invoiceTotal : '';
        const caseNumber: any = it.occasion?.caseNumber;
        createdAt = createdAt ? `${changeToZeroMoment(createdAt, 'MMM D, YYYY')}` : '';
        const student = it.student ? `${it.student?.firstName} ${it.student?.lastName}` : '';
        const district: any = it?.district ? it?.district.name : '';

        let serviceType = it.occasion?.serviceType?.title;
        if (!serviceType) {
            serviceType = it.occasion?.serviceType?.cpt;
        }
        let valueOrderPeriod = it.periodStart;
        valueOrderPeriod = valueOrderPeriod ? `${changeToZeroMoment(valueOrderPeriod, 'MMM D, YYYY')}` : '';

        let valueOrderType: any = orderTypes.find((itp) => itp.value === it?.occasion?.orderType);
        valueOrderType = valueOrderType ? valueOrderType.label : '';

        const note: any = it?.note ? it.note : '';
        const reason: any = it?.reason ? it.reason : '';
        let valuestatus: any = statuses.find((its) => +its.value === +it.status);
        valuestatus = valuestatus ? valuestatus.label : '';

        groupData.push([
            it.id,
            createdAt,
            invoiceTotal ? `$${numberWithCommas(invoiceTotal)}` : `$0.00`,
            caseNumber ? caseNumber : 0,
            providerTitle,
            student,
            vendor ? vendor : '',
            district ? district : '',
            serviceType ? serviceType : '',
            valueOrderPeriod,
            valueOrderType ? valueOrderType : '',
            note,
            valuestatus ? valuestatus : '',
            reason,
        ]);
    });

    return groupData;
};
